// export const BASE_URL = 'https://beehive-mirror-api.beetronix.com/api/';
// export const BASE_URL = 'https://beehive-api.beetronix.com/api/'; // al maseer
// export const BASE_URL = 'http://beeserver:86/Api/';

// export const BASE_URL = 'https://hr-api.beetronix.com/api'

// export const BASE_URL = 'https://beehive-mirror-api.beetronix.com/api'
// export const BASE_URL = 'https://mirta-hr-api.beetronix.com/api'

// export const BASE_URL = 'https://beehive.beetronix.com/api'
// export const BASE_URL = 'https://localhost:7258/api/';
// export const BASE_URL = 'https://hr-api.beetronix.com/api/'; // beetronix
// export const BASE_URL = 'https://hr-arfada-api.beetronix.com/api/'; // arfada
// export const BASE_URL = 'https://beehive-demo-api.beetronix.com/api'
// export const BASE_URL = 'https://beehive-demo-api.beetronix.com/api'
// export const BASE_URL = 'https://delta-hr-api.beetronix.com/api'
// export const BASE_URL = 'https://localhost:7258/api'
export const BASE_URL = 'https://hr-api.rowadalmustakbal.edunixsystem.com/api/'
export const VERSION = '2.0.0';

export const STORAGE = {
	CASH: 'CASH',
};
